import React from 'react';
import AppButton from './AppButton';
import AppModal from './AppModal';

const AppConfirmModal = ({
  show,
  title,
  children,
  confirmLabel = 'Confirmer',
  confirmVariant = 'primary',
  confirmIcon,
  saving = false,
  savingLabel = 'Patientez…',
  cancelLabel = 'Annuler',
  onConfirm,
  onClose,
  centered = true,
  ...modalProps
}) => (
  <AppModal
    show={show}
    title={title}
    onClose={onClose}
    centered={centered}
    footer={(
      <>
        <AppButton variant="outline-secondary" onClick={onClose} disabled={saving}>
          {cancelLabel}
        </AppButton>
        <AppButton
          variant={confirmVariant}
          icon={saving ? undefined : confirmIcon}
          loading={saving}
          loadingLabel={savingLabel}
          onClick={onConfirm}
        >
          {confirmLabel}
        </AppButton>
      </>
    )}
    {...modalProps}
  >
    {children}
  </AppModal>
);

export default AppConfirmModal;
